import React from 'react';
import { Row, Col, Tabs, Tab } from 'react-bootstrap';
import FittingDashboardContainer from '../containers/FittingDashboardContainer.jsx';
import FittingOrderersContainer from '../containers/FittingOrderersContainer.jsx';
import FittingRecordsContainer from '../containers/FittingRecordsContainer.jsx';
import FittingBatchContainer from '../containers/FittingBatchContainer.jsx';
import FittingOrdererUploadContainer from '../containers/FittingOrdererUploadContainer.jsx';

import DropDownInput from './common/DropDownInput.jsx';

export default class FittingComponent extends React.Component {

  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    this.props.findAllOrderIds();
    if (this.props.orderId) {
      if (this.props.eventKey === 0) {
        this.props.findFittingDashboard({ orderId: this.props.orderId });
      } else if (this.props.eventKey === 1) {
        this.props.findFittingList({ orderId: this.props.orderId });
      } else if (this.props.eventKey === 2) {
        this.props.findFittingList({ orderId: this.props.orderId });
        this.props.findDetailsNeedBespoke({ orderId: this.props.orderId });
      } else if (this.props.eventKey === 3) {
        this.props.findFittingBatchList({ orderId: this.props.orderId });
        this.props.findDetailsNeedBespoke({ orderId: this.props.orderId });
      }
    }
  }

  handleSelect(key) {
    this.props.changeEventKey(key);
    if (key === 0) {
      this.props.findFittingDashboard({ orderId: this.props.orderId });
    } else if (key === 1) {
      this.props.findFittingList({ orderId: this.props.orderId });
    } else if (key === 2) {
      this.props.findFittingList({ orderId: this.props.orderId });
      this.props.findDetailsNeedBespoke({ orderId: this.props.orderId });
    } else if (key === 3) {
      this.props.findFittingBatchList({ orderId: this.props.orderId });
      this.props.findDetailsNeedBespoke({ orderId: this.props.orderId });
    }
  }

  render() {

    let roles = this.props.roles;
    let showFittingCrud = !(roles.includes("ROLE_FIREFIGHTER_FITTING_CRUD"));

    return (
      <div>
        <h4>套量管理</h4>
        <Row style={{ marginLeft: -15, marginRight: -15 }}>
          <Col xs={6} sm={3} md={3}>
            <DropDownInput id="orderId"
              label="訂單編號"
              options={this.props.allOrderIds.map((value, key) => ({ label: value, value: value })).toJS()}
              selected={[{ label: this.props.orderId, value: this.props.orderId }]}
              onChange={(id, value, label) => {
                this.props.changeOrderId({ orderId: value });
                if (this.props.eventKey === 0) {
                  this.props.findFittingDashboard({ orderId: value });
                } else if (this.props.eventKey === 1) {
                  this.props.findFittingList({ orderId: value });
                } else if (this.props.eventKey === 2) {
                  this.props.findFittingList({ orderId: value });
                  this.props.findDetailsNeedBespoke({ orderId: value });
                } else if (this.props.eventKey === 3) {
                  this.props.findFittingBatchList({ orderId: value });
                  this.props.findDetailsNeedBespoke({ orderId: value });
                }
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginLeft: -15, marginRight: -15 }}>
        <Col xs={12}>
          <Tabs id="editTab" defaultActiveKey={this.props.eventKey} animation={false} onSelect={this.handleSelect}>
            <Tab eventKey={0} title="總覽">
              <FittingDashboardContainer />
            </Tab>
            <Tab eventKey={1} title="訂購人" disabled={showFittingCrud}>
              <FittingOrderersContainer />
            </Tab>
            <Tab eventKey={2} title="套量">
              <FittingRecordsContainer />
            </Tab>
            <Tab eventKey={5} title="訂購人/套量 匯入" disabled={showFittingCrud}>
              <FittingOrdererUploadContainer />
            </Tab>
            <Tab eventKey={3} title="批次">
              <FittingBatchContainer />
            </Tab>
          </Tabs>
          </Col>
        </Row>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/FittingComponent.jsx